var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.534 13.139L6.194 7.76a.667.667 0 010-.94l.622-.626a.656.656 0 01.932-.002L12 10.456l4.252-4.263a.656.656 0 01.932.002l.623.627c.257.26.257.68 0 .939l-5.34 5.378a.656.656 0 01-.933 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.534 10.861l-5.34 5.378a.667.667 0 000 .94l.622.627c.257.258.674.259.932 0L12 13.545l4.252 4.263a.656.656 0 00.932-.002l.623-.627a.667.667 0 000-.939l-5.34-5.378a.656.656 0 00-.933 0z"
  })));
}

export default SvgCross;